import {
  COST_PER_ADD_TO_CART_META,
  ADD_TO_CART_META,
  COST_PER_WEB_IN_STORE_PURCHASE_META,
  WEB_IN_STORE_PURCHASE_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_SEARCH_META,
  OFFSITE_CONVERSION_FB_PIXEL_SEARCH_META,
  COST_PER_LINK_CLICK_META,
  LINK_CLICK_META,
  COST_PER_PAGE_ENGAGEMENT_META,
  PAGE_ENGAGEMENT_META,
  COST_PER_PURCHASE_META,
  PURCHASE_META,
  COST_PER_LANDING_PAGE_VIEW_META,
  LANDING_PAGE_VIEW_META,
  COST_PER_POST_ENGAGEMENT_META,
  POST_ENGAGEMENT_META,
  COST_PER_ONSITE_WEB_VIEW_CONTENT_META,
  ONSITE_WEB_VIEW_CONTENT_META,
  COST_PER_ONSITE_WEB_ADD_TO_CART_META,
  ONSITE_WEB_ADD_TO_CART_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_ADD_PAYMENT_INFO_META,
  OFFSITE_CONVERSION_FB_PIXEL_ADD_PAYMENT_INFO_META,
  COST_PER_COMMENT_META,
  COMMENT_META,
  COST_PER_ONSITE_WEB_APP_PURCHASE_META,
  ONSITE_WEB_APP_PURCHASE_META,
  COST_PER_OFFSITE_CONTENT_VIEW_ADD_META_LEADS_META,
  OFFSITE_CONTENT_VIEW_ADD_META_LEADS_META,
  COST_PER_VIEW_CONTENT_META,
  VIEW_CONTENT_META,
  COST_PER_WEB_APP_IN_STORE_PURCHASE_META,
  WEB_APP_IN_STORE_PURCHASE_META,
  COST_PER_ONSITE_WEB_APP_ADD_TO_CART_META,
  ONSITE_WEB_APP_ADD_TO_CART_META,
  COST_PER_OFFSITE_SEARCH_ADD_META_LEADS_META,
  OFFSITE_SEARCH_ADD_META_LEADS_META,
  COST_PER_POST_META,
  POST_META,
  COST_PER_ONSITE_CONVERSION_POST_SAVE_META,
  ONSITE_CONVERSION_POST_SAVE_META,
  COST_PER_ONSITE_WEB_INITIATE_CHECKOUT_META,
  ONSITE_WEB_INITIATE_CHECKOUT_META,
  COST_PER_ONSITE_CONVERSION_POST_NET_SAVE_META,
  ONSITE_CONVERSION_POST_NET_SAVE_META,
  COST_PER_ONSITE_WEB_APP_VIEW_CONTENT_META,
  ONSITE_WEB_APP_VIEW_CONTENT_META,
  COST_PER_POST_INTERACTION_GROSS_META,
  POST_INTERACTION_GROSS_META,
  COST_PER_ONSITE_WEB_PURCHASE_META,
  ONSITE_WEB_PURCHASE_META,
  COST_PER_ADD_PAYMENT_INFO_META,
  ADD_PAYMENT_INFO_META,
  COST_PER_SEARCH_META,
  SEARCH_META,
  COST_PER_VIDEO_VIEW_META,
  VIDEO_VIEW_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_VIEW_CONTENT_META,
  OFFSITE_CONVERSION_FB_PIXEL_VIEW_CONTENT_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_ADD_TO_CART_META,
  OFFSITE_CONVERSION_FB_PIXEL_ADD_TO_CART_META,
  COST_PER_POST_REACTION_META,
  POST_REACTION_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_INITIATE_CHECKOUT_META,
  OFFSITE_CONVERSION_FB_PIXEL_INITIATE_CHECKOUT_META,
  COST_PER_OFFSITE_CONVERSION_FB_PIXEL_PURCHASE_META,
  OFFSITE_CONVERSION_FB_PIXEL_PURCHASE_META,
  COST_PER_INITIATE_CHECKOUT_META,
  INITIATE_CHECKOUT_META,
  COST_PER_LIKE_META,
  LIKE_META,
} from "../../../../i18n/keysTranslations";
import { META } from "../../../../utils/constants";

/**
 * Configuración de métricas de acción para estadísticas de campañas.
 * Define cómo mapear los action_type que vienen de la BD a métricas
 * con sus respectivas traducciones y nombres de métricas.
 */
export const METRICS_TO_BROKEN_DOWN_BY_PLATFORM = {
  [META]: [
    {
      key: "add_to_cart",
      countMetricName: "addToCart",
      costMetricName: "costPerAddToCart",
      countLabelKey: ADD_TO_CART_META,
      costLabelKey: COST_PER_ADD_TO_CART_META,
    },
    {
      key: "web_in_store_purchase",
      countMetricName: "webInStorePurchase",
      costMetricName: "costPerWebInStorePurchase",
      countLabelKey: WEB_IN_STORE_PURCHASE_META,
      costLabelKey: COST_PER_WEB_IN_STORE_PURCHASE_META,
    },
    {
      key: "offsite_conversion.fb_pixel_search",
      countMetricName: "offsiteConversionFbPixelSearch",
      costMetricName: "costPerOffsiteConversionFbPixelSearch",
      countLabelKey: OFFSITE_CONVERSION_FB_PIXEL_SEARCH_META,
      costLabelKey: COST_PER_OFFSITE_CONVERSION_FB_PIXEL_SEARCH_META,
    },
    {
      key: "link_click",
      countMetricName: "linkClick",
      costMetricName: "costPerLinkClick",
      countLabelKey: LINK_CLICK_META,
      costLabelKey: COST_PER_LINK_CLICK_META,
    },
    {
      key: "page_engagement",
      countMetricName: "pageEngagement",
      costMetricName: "costPerPageEngagement",
      countLabelKey: PAGE_ENGAGEMENT_META,
      costLabelKey: COST_PER_PAGE_ENGAGEMENT_META,
    },
    {
      key: "purchase",
      countMetricName: "purchase",
      costMetricName: "costPerPurchase",
      countLabelKey: PURCHASE_META,
      costLabelKey: COST_PER_PURCHASE_META,
    },
    {
      key: "landing_page_view",
      countMetricName: "landingPageView",
      costMetricName: "costPerLandingPageView",
      countLabelKey: LANDING_PAGE_VIEW_META,
      costLabelKey: COST_PER_LANDING_PAGE_VIEW_META,
    },
    {
      key: "post_engagement",
      countMetricName: "postEngagement",
      costMetricName: "costPerPostEngagement",
      countLabelKey: POST_ENGAGEMENT_META,
      costLabelKey: COST_PER_POST_ENGAGEMENT_META,
    },
    {
      key: "onsite_web_view_content",
      countMetricName: "onsiteWebViewContent",
      costMetricName: "costPerOnsiteWebViewContent",
      countLabelKey: ONSITE_WEB_VIEW_CONTENT_META,
      costLabelKey: COST_PER_ONSITE_WEB_VIEW_CONTENT_META,
    },
    {
      key: "onsite_web_add_to_cart",
      countMetricName: "onsiteWebAddToCart",
      costMetricName: "costPerOnsiteWebAddToCart",
      countLabelKey: ONSITE_WEB_ADD_TO_CART_META,
      costLabelKey: COST_PER_ONSITE_WEB_ADD_TO_CART_META,
    },
    {
      key: "offsite_conversion.fb_pixel_add_payment_info",
      countMetricName: "offsiteConversionFbPixelAddPaymentInfo",
      costMetricName: "costPerOffsiteConversionFbPixelAddPaymentInfo",
      countLabelKey: OFFSITE_CONVERSION_FB_PIXEL_ADD_PAYMENT_INFO_META,
      costLabelKey: COST_PER_OFFSITE_CONVERSION_FB_PIXEL_ADD_PAYMENT_INFO_META,
    },
    {
      key: "comment",
      countMetricName: "comment",
      costMetricName: "costPerComment",
      countLabelKey: COMMENT_META,
      costLabelKey: COST_PER_COMMENT_META,
    },
    {
      key: "onsite_web_app_purchase",
      countMetricName: "onsiteWebAppPurchase",
      costMetricName: "costPerOnsiteWebAppPurchase",
      countLabelKey: ONSITE_WEB_APP_PURCHASE_META,
      costLabelKey: COST_PER_ONSITE_WEB_APP_PURCHASE_META,
    },
    {
      key: "offsite_content_view_add_meta_leads",
      countMetricName: "offsiteContentViewAddMetaLeads",
      costMetricName: "costPerOffsiteContentViewAddMetaLeads",
      countLabelKey: OFFSITE_CONTENT_VIEW_ADD_META_LEADS_META,
      costLabelKey: COST_PER_OFFSITE_CONTENT_VIEW_ADD_META_LEADS_META,
    },
    {
      key: "view_content",
      countMetricName: "viewContent",
      costMetricName: "costPerViewContent",
      countLabelKey: VIEW_CONTENT_META,
      costLabelKey: COST_PER_VIEW_CONTENT_META,
    },
    {
      key: "web_app_in_store_purchase",
      countMetricName: "webAppInStorePurchase",
      costMetricName: "costPerWebAppInStorePurchase",
      countLabelKey: WEB_APP_IN_STORE_PURCHASE_META,
      costLabelKey: COST_PER_WEB_APP_IN_STORE_PURCHASE_META,
    },
    {
      key: "onsite_web_app_add_to_cart",
      countMetricName: "onsiteWebAppAddToCart",
      costMetricName: "costPerOnsiteWebAppAddToCart",
      countLabelKey: ONSITE_WEB_APP_ADD_TO_CART_META,
      costLabelKey: COST_PER_ONSITE_WEB_APP_ADD_TO_CART_META,
    },
    {
      key: "offsite_search_add_meta_leads",
      countMetricName: "offsiteSearchAddMetaLeads",
      costMetricName: "costPerOffsiteSearchAddMetaLeads",
      countLabelKey: OFFSITE_SEARCH_ADD_META_LEADS_META,
      costLabelKey: COST_PER_OFFSITE_SEARCH_ADD_META_LEADS_META,
    },
    {
      key: "post",
      countMetricName: "post",
      costMetricName: "costPerPost",
      countLabelKey: POST_META,
      costLabelKey: COST_PER_POST_META,
    },
    {
      key: "onsite_conversion.post_save",
      countMetricName: "onsiteConversionPostSave",
      costMetricName: "costPerOnsiteConversionPostSave",
      countLabelKey: ONSITE_CONVERSION_POST_SAVE_META,
      costLabelKey: COST_PER_ONSITE_CONVERSION_POST_SAVE_META,
    },
    {
      key: "onsite_web_initiate_checkout",
      countMetricName: "onsiteWebInitiateCheckout",
      costMetricName: "costPerOnsiteWebInitiateCheckout",
      countLabelKey: ONSITE_WEB_INITIATE_CHECKOUT_META,
      costLabelKey: COST_PER_ONSITE_WEB_INITIATE_CHECKOUT_META,
    },
    {
      key: "onsite_conversion.post_net_save",
      countMetricName: "onsiteConversionPostNetSave",
      costMetricName: "costPerOnsiteConversionPostNetSave",
      countLabelKey: ONSITE_CONVERSION_POST_NET_SAVE_META,
      costLabelKey: COST_PER_ONSITE_CONVERSION_POST_NET_SAVE_META,
    },
    {
      key: "onsite_web_app_view_content",
      countMetricName: "onsiteWebAppViewContent",
      costMetricName: "costPerOnsiteWebAppViewContent",
      countLabelKey: ONSITE_WEB_APP_VIEW_CONTENT_META,
      costLabelKey: COST_PER_ONSITE_WEB_APP_VIEW_CONTENT_META,
    },
    {
      key: "post_interaction_gross",
      countMetricName: "postInteractionGross",
      costMetricName: "costPerPostInteractionGross",
      countLabelKey: POST_INTERACTION_GROSS_META,
      costLabelKey: COST_PER_POST_INTERACTION_GROSS_META,
    },
    {
      key: "onsite_web_purchase",
      countMetricName: "onsiteWebPurchase",
      costMetricName: "costPerOnsiteWebPurchase",
      countLabelKey: ONSITE_WEB_PURCHASE_META,
      costLabelKey: COST_PER_ONSITE_WEB_PURCHASE_META,
    },
    {
      key: "add_payment_info",
      countMetricName: "addPaymentInfo",
      costMetricName: "costPerAddPaymentInfo",
      countLabelKey: ADD_PAYMENT_INFO_META,
      costLabelKey: COST_PER_ADD_PAYMENT_INFO_META,
    },
    {
      key: "search",
      countMetricName: "search",
      costMetricName: "costPerSearch",
      countLabelKey: SEARCH_META,
      costLabelKey: COST_PER_SEARCH_META,
    },
    {
      key: "video_view",
      countMetricName: "videoView",
      costMetricName: "costPerVideoView",
      countLabelKey: VIDEO_VIEW_META,
      costLabelKey: COST_PER_VIDEO_VIEW_META,
    },
    {
      key: "offsite_conversion.fb_pixel_view_content",
      countMetricName: "offsiteConversionFbPixelViewContent",
      costMetricName: "costPerOffsiteConversionFbPixelViewContent",
      countLabelKey: OFFSITE_CONVERSION_FB_PIXEL_VIEW_CONTENT_META,
      costLabelKey: COST_PER_OFFSITE_CONVERSION_FB_PIXEL_VIEW_CONTENT_META,
    },
    {
      key: "offsite_conversion.fb_pixel_add_to_cart",
      countMetricName: "offsiteConversionFbPixelAddToCart",
      costMetricName: "costPerOffsiteConversionFbPixelAddToCart",
      countLabelKey: OFFSITE_CONVERSION_FB_PIXEL_ADD_TO_CART_META,
      costLabelKey: COST_PER_OFFSITE_CONVERSION_FB_PIXEL_ADD_TO_CART_META,
    },
    {
      key: "post_reaction",
      countMetricName: "postReaction",
      costMetricName: "costPerPostReaction",
      countLabelKey: POST_REACTION_META,
      costLabelKey: COST_PER_POST_REACTION_META,
    },
    {
      key: "offsite_conversion.fb_pixel_initiate_checkout",
      countMetricName: "offsiteConversionFbPixelInitiateCheckout",
      costMetricName: "costPerOffsiteConversionFbPixelInitiateCheckout",
      countLabelKey: OFFSITE_CONVERSION_FB_PIXEL_INITIATE_CHECKOUT_META,
      costLabelKey: COST_PER_OFFSITE_CONVERSION_FB_PIXEL_INITIATE_CHECKOUT_META,
    },
    {
      key: "offsite_conversion.fb_pixel_purchase",
      countMetricName: "offsiteConversionFbPixelPurchase",
      costMetricName: "costPerOffsiteConversionFbPixelPurchase",
      countLabelKey: OFFSITE_CONVERSION_FB_PIXEL_PURCHASE_META,
      costLabelKey: COST_PER_OFFSITE_CONVERSION_FB_PIXEL_PURCHASE_META,
    },
    {
      key: "initiate_checkout",
      countMetricName: "initiateCheckout",
      costMetricName: "costPerInitiateCheckout",
      countLabelKey: INITIATE_CHECKOUT_META,
      costLabelKey: COST_PER_INITIATE_CHECKOUT_META,
    },
    {
      key: "like",
      countMetricName: "like",
      costMetricName: "costPerLike",
      countLabelKey: LIKE_META,
      costLabelKey: COST_PER_LIKE_META,
    },
  ],
};
